module.exports = __webpack_public_path__ + "dashboard/img/clean.6c83d3bc5184a8794c043aae377979a0.svg";